
import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
  {
    question: "Quand vais-je recevoir l'argent de ma vente ?",
    answer:
      "L'argent de la vente est généralement versé sur votre compte bancaire quelques jours après la signature de l'acte authentique chez le notaire. Le délai peut varier en fonction des établissements bancaires et des modalités de la transaction.",
  },
  {
    question: "Quels sont les délais pour finaliser la vente de son bien immobilier ?",
    answer:
      "Le délai moyen entre la signature du compromis de vente et l'acte définitif est d'environ 3 mois. Ce délai peut varier en fonction de divers facteurs tels que l'obtention du prêt par l'acheteur, la réalisation des diagnostics obligatoires, ou encore les délais administratifs.",
  },
  {
    question: "Quels documents dois-je fournir au notaire pour la vente de mon bien immobilier ?",
    answer:
      "Vous devrez fournir plusieurs documents, notamment :\n\n• Le titre de propriété du bien.\n• Les diagnostics techniques obligatoires (DPE, amiante, plomb, etc.).\n• Les derniers avis de taxe foncière et d'habitation.\n• Le règlement de copropriété et les procès-verbaux des assemblées générales des 3 dernières années si le bien est en copropriété.",
  },
  {
    question: "Puis-je changer de notaire en cours de transaction ?",
    answer:
      "Oui, il est possible de changer de notaire en cours de transaction. Cependant, cela peut entraîner des délais supplémentaires. Il est recommandé d'en discuter avec toutes les parties concernées pour assurer une transition en douceur.",
  },
  {
    question: "Les clauses suspensives qu’est-ce que c’est ?",
    answer:
      "Les clauses suspensives sont des conditions prévues dans le compromis de vente qui doivent être remplies pour que la vente soit définitive. Par exemple, l'obtention d'un prêt immobilier par l'acheteur est une clause suspensive courante. Si la condition n'est pas remplie, la vente peut être annulée sans pénalité.",
  },
  {
    question: "Les frais de notaire, qu’est-ce que c’est ?",
    answer:
      "Les frais de notaire comprennent les taxes, les débours et la rémunération du notaire. Ils sont généralement à la charge de l'acheteur, sauf accord contraire. Ces frais représentent environ 7 à 8 % du prix de vente pour un bien ancien.",
  },
];

function Faq() {
  return (
    <section className="mt-10">
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6  lg:px-8 ">
        <div className="mx-auto max-w-4xl">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Questions les plus fréquentes des vendeurs immobilier chez le notaire
          </h2>
          <dl className="mt-16 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
                <dt>
                  <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                    <span className="text-base/7 font-semibold">{faq.question}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <PlusSmallIcon aria-hidden="true" className="size-6 group-data-open:hidden" />
                      <MinusSmallIcon aria-hidden="true" className="size-6 group-not-data-open:hidden" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" className="mt-2 pr-12">
                  <p className="text-base/7 text-gray-600">{faq.answer}</p>
                </DisclosurePanel>
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
    </section>
  );
}

export default Faq;
